/* eslint-disable no-console */
import config from "config";

const myFetch = async (url, type = "json", setError) => {
  try {
    const answer = await fetch(url);
    if (answer.ok) {
      if (type === "json") {
        const data = await answer.json();
        return data;
      }
      if (type === "blob") {
        const blob = await answer.blob();
        const src = URL.createObjectURL(blob);
        return src;
      }
      throw new Error("This type is not supported");
    } else {
      setError(`${answer.statusText}`);
    }
  } catch (e) {
    if (setError) {
      setError(`${e}`);
    } else {
      console.error("e: ", e);
    }
    return null;
  }
};

export const getTranslation = async ({ location }, setTLocation) => {
  const lng = localStorage.lng || "en";
  const url = `${config.translate}&text=${location}&lang=${
    lng === "by" ? "be" : lng
  }`;
  try {
    const data = await myFetch(url);
    console.log("data: ", data);
    console.log("data.text[0]: ", data.text[0]);
    setTLocation(data.text[0]);
  } catch (error) {
    console.error(error);
  }
};

export const getMyGeolocation = async (setGeoData, setError) => {
  const data = await myFetch(config.myGeolocation, "json", setError);

  const { loc } = data;
  const arrLoc = await loc.split(",");

  setGeoData({ lat: arrLoc[0], lng: arrLoc[1] });
};

const transformWeatherData = ([todayWeather, sixteenDayWeather]) => {
  const weather = {};
  todayWeather.then((resolve) => {
    const {
      data: [
        {
          app_temp: appTemp,
          temp,
          rh,
          weather: { code, icon },
          wind_spd: windSpd,
        },
      ],
    } = resolve;
    weather.todayWeather = { appTemp, temp, rh, code, icon, windSpd };
  });
  sixteenDayWeather.then((resolve) => {
    const { data } = resolve;
    const newData = data.slice(1).map((item) => {
      const {
        temp,
        weather: { icon },
        valid_date: date,
      } = item;
      return { temp, icon, date };
    });
    weather.fifteenWeather = newData;
  });

  return weather;
};

export const getWeather = async ({ lat, lng }, setWeather, setError) => {
  if (!lat && !lng) {
    return;
  }
  const lang = localStorage.lng || "en";
  const url = `${config.weatherbitHourlyUrl}&lat=${lat}&lon=${lng}&lang=${lang}&hours=24`;
  const url2 = `${config.weatherbitDailyUrl}&lat=${lat}&lon=${lng}&lang=${lang}`;
  const ArrFetch = [
    myFetch(url, "json", setError),
    myFetch(url2, "json", setError),
  ];
  Promise.all(ArrFetch);

  setWeather(transformWeatherData(ArrFetch));
};

export const getBGImage = async ({ location }, setBG, setError) => {
  if (!location) {
    return;
  }
  const url = `${config.unsplashUrl}{${location} city}`;

  const imgData = await myFetch(url, "json", setError);
  console.log("img: ", imgData);
  if (imgData) {
    const { urls } = imgData;

    const src = await myFetch(urls.regular, "blob");

    setBG(src);
  }
};

export const getOpencageData = async (
  isSearch,
  region,
  geoData,
  setGeoData,
  setTLocation,
  setError
) => {
  const language = localStorage.lng || "en";
  const getCity = (city) => (city ? city.split(" ").join("%20") : "");
  const forwardUrl = `${config.forwardUrl}${getCity(
    region
  )}&language=${language}`;
  const reverseUrl = `${config.reverseUrl}${geoData.lat}+${geoData.lng}&language=${language}`;
  const url = isSearch ? forwardUrl : reverseUrl;
  const answer = await myFetch(url, "json", setError);

  const [geoAnswer] = answer.results;
  if (!geoAnswer) {
    setError(true);
    return;
  }

  const {
    geometry: { lng, lat },
    annotations: {
      DMS,
      timezone: { offset_sec: offsetSec },
    },
    components: { city, county, town, village, state, country },
  } = geoAnswer;
  const location = `${city || town || county || village || ""} ${
    state || ""
  } ${country}`;
  if (isSearch) {
    setGeoData({
      lng,
      lat,
      DMS,
      location,
      offsetSec,
    });
  } else {
    setGeoData({ ...geoData, DMS, location, offsetSec });
  }
  setTLocation("");
  setError(false);
};
